require('./RAPillButtons.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @components
const RAPillButton = require('./RAPillButton');

class RAPillButtons extends React.Component {
    render() {
        const {
            buttons,
            formatter,
            changeOption,
            selectedOption,
            disabled,
        } = this.props;

        const mappedButtons = buttons.map((b, idx) => {
            return (
                <RAPillButton
                    key={idx}
                    value={b}
                    formatter={formatter}
                    changeOption={changeOption}
                    selectedOption={selectedOption}
                    disabled={disabled}
                />
            );
        });

        return <div className="ra-pill-buttons">{mappedButtons}</div>;
    }
}

RAPillButtons.propTypes = {
    buttons: PropTypes.array.isRequired,
    changeOption: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    formatter: PropTypes.func,
    selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
};

module.exports = RAPillButtons;
